/**
 * @file
 * Old AMD key: `ac/jira/workflow-post-function`
 */

import type { ACJSHost, ExtensionData } from '../../../types';
import type {
	DataValueWithValidType,
	WorkflowSubmissionCallback,
	ConnectCallbackWorkflowConfig,
} from './types';
import {
	getWorkflowElementId,
	getWorkflowElementName,
	isOnWorkflowElementPage,
	isWorkflowElementExtension,
	registerSubmissionButton,
	workflowElementConfigInput,
} from './utils';

// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let workflowSubmissionCallback: WorkflowSubmissionCallback = () => {}; // noop

export const registerWorkflowEvents = (connectHost: ACJSHost) => {
	connectHost.onIframeEstablished((ext: ExtensionData) => {
		const { moduleType } = ext.extension.options;

		if (
			moduleType &&
			isOnWorkflowElementPage(moduleType) &&
			isWorkflowElementExtension(ext.extension)
		) {
			const workflowElementId = getWorkflowElementId(moduleType);

			if (typeof workflowElementId === 'string') {
				registerSubmissionButton(moduleType, workflowElementId, (callback) => {
					workflowSubmissionCallback = callback;

					connectHost.broadcastEvent('jira_workflow_post_function_submit', {
						id: ext.extension.id,
					});
				});
			}
		}
	});
};

/**
 * Retrieves a workflow configuration object.
 * @memberof module:Jira
 * @method getWorkflowConfiguration
 * @param {WorkflowConfiguration} callback - the callback that handles the response.
 */
export const getWorkflowConfiguration = (callback?: ConnectCallbackWorkflowConfig): boolean => {
	if (typeof callback !== 'function') {
		return false;
	}

	const { moduleType } = callback._context.extension.options;

	if (!moduleType || !isOnWorkflowElementPage(moduleType)) {
		return false;
	}

	const productContext = callback._context.extension?.options?.productContext;

	const val = workflowElementConfigInput(
		moduleType,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		productContext?.[`${getWorkflowElementName(moduleType)}.id`] as string,
	);

	if (callback) {
		callback(val);
	}

	return true;
};

export const _submitWorkflowConfigurationResponse = (data: DataValueWithValidType) => {
	workflowSubmissionCallback(data);
};
